var _rect, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 633,
    height: 633,
    viewBox: "0 0 633 633",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 633,
    height: 633,
    fill: "#0073B2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 184.5,
    r: 42.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.5 258H149V490H220.5V258Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M335 258H266.5V490.5H338.5L338 369C338 369 337.994 362.27 338.5 358C339.426 350.193 340.084 345.58 343.5 338.5C346.656 331.957 348.802 328.005 354.5 323.5C361.044 318.326 366.241 317.172 374.5 316C381.856 314.955 386.464 314.611 393.5 317C404.097 320.598 410 326 414.5 336.5C419.5 348.5 419.5 365 419.5 365V490.5H491V490V402V364.5C491 364.5 491.195 354.44 491 348C490.65 336.443 490.906 329.808 488.5 318.5C486.135 307.386 484.428 300.982 479 291C473.552 280.979 469.745 275.322 461 268C443.601 253.433 416.833 252 405 252.5C391.867 252.293 384.074 253.828 372 259C354.439 266.522 340.167 282.666 335 291V258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLogo);
export default __webpack_public_path__ + "static/media/LinkedInLogo.1f644a384a2eb811a8c70ddaffe0fb9b.svg";
export { ForwardRef as ReactComponent };